
export default function getCountryFromPreferredLanguages (preferredLanguages) {
  let preferredLanguage;
  for (preferredLanguage of preferredLanguages) {
    let splitLanguage = preferredLanguage.split('-');
    if (splitLanguage.length > 1) { // if this language is like "en-US"
      return splitLanguage[1].toUpperCase();
    }
  }

  for (preferredLanguage of preferredLanguages) {
    switch (preferredLanguage) {
      case 'en':
        return 'US';
      case 'fr':
        return 'FR';
      case 'de':
        return 'DE';
      case 'es':
        return 'ES';
      case 'it':
        return 'IT';
      case 'ru':
        return 'RU';
      case 'pl':
        return 'PL';
      case 'tr':
        return 'TR';
      case 'cs':
        return 'CZ';
      case 'ko':
        return 'KR';
      case 'pt':
        return 'BR';
      case 'zh':
        return 'CN';
      default:
        return 'US';

    }
  }

}




// WEBPACK FOOTER //
// ./lib/rlink-regions/getCountryFromPreferredLanguages.js